let tenantSlug = null;

function extractSlug(host) {
  if (!host) return null;
  const normalized = String(host).trim().toLowerCase();
  if (!normalized) return null;
  const withoutPort = normalized.split(":")[0];
  if (!withoutPort) return null;
  if (withoutPort === "localhost" || withoutPort === "127.0.0.1" || withoutPort === "0.0.0.0") {
    return null;
  }
  if (withoutPort.startsWith("[") && withoutPort.endsWith("]")) {
    return null;
  }
  if (/^\d{1,3}(?:\.\d{1,3}){3}$/.test(withoutPort)) {
    return null;
  }
  const parts = withoutPort.split(".");
  if (parts.length < 2) {
    return null;
  }
  return parts[0] || null;
}

export function initTenantSlug() {
  if (typeof window === "undefined") {
    tenantSlug = null;
    return tenantSlug;
  }
  tenantSlug = extractSlug(window.location?.host || "") || null;
  return tenantSlug;
}

export function getTenantSlug() {
  return tenantSlug;
}

export function setTenantSlugForTests(slug) {
  tenantSlug = slug || null;
}
